import type { Passenger } from '@bambi/api-client/schemas';
import { Button } from '@bambi/component-library/src/components/Button/Button';

import { PassengerFormDialog } from '../passenger/PassengerForm/PassengerFormDialog';
import { addATrip } from './addATrip.slice';
import { AddATripFlowDialog } from './AddATripFlowDialog';
import { AddATripFlowForm } from './AddATripFlowForm';
import { AddATripPricingFormProvider } from './AddATripPricingFormProvider';
import { PricingFormSection } from './Pricing';
import { ServiceDetailsFormSection } from './ServiceDetails';
import { TripBookedBySection } from './TripBookedBySection';
import { TripDetailsFormSection } from './TripDetails';
import { TripPayerInactiveWarning } from './TripPayerInactiveWarning';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import type { RootState } from 'src/app/store/types';
import { PassengerInfoFormSection } from 'src/features/add-trip/PassengerInfoFormSection';

export function AddATripFlow() {
  const dispatch = useAppDispatch();
  const passenger: Passenger | null | undefined = useAppSelector(
    (state: RootState) => state.addATrip.selectedPassenger
  );

  const selectedPayer = useAppSelector(
    (state: RootState) => state.addATrip.selectedPayer
  );

  const isEditingPassenger = useAppSelector(
    (state: RootState) => state.addATrip.isEditingPassenger
  );

  const onPassengerSelected = (passenger: Passenger | undefined) => {
    dispatch(addATrip.actions.selectPassenger(passenger));
  };

  const onPassengerEdit = (passenger: Passenger) => {
    // TODO: Need to move passenger crud to be more global to get around this dumb hack.
    // This supports the following use case:
    // 1. Click edit passenger after selecting one
    // 2. Click cancel (causing the form state to reset)
    // 3. Click edit again for whatever reason
    // Wanted to keep changes to the passenger form editing as small as possible
    const temp = { ...passenger };
    dispatch(addATrip.actions.selectNoPassenger());
    dispatch(addATrip.actions.selectPassenger(temp));
    dispatch(addATrip.actions.setIsEditingPassenger(true));
  };

  return (
    <>
      <Button
        variant="primary-outline"
        onClick={() => dispatch(addATrip.actions.open())}
      >
        Add Trip
      </Button>
      <AddATripFlowDialog>
        <AddATripFlowForm>
          {selectedPayer && !selectedPayer.is_active && (
            <TripPayerInactiveWarning />
          )}
          <PassengerInfoFormSection
            selectedPassenger={passenger}
            onPassengerSelected={onPassengerSelected}
            onPassengerEdit={onPassengerEdit}
          />
          <AddATripPricingFormProvider>
            <PricingFormSection />
          </AddATripPricingFormProvider>
          <ServiceDetailsFormSection />
          <TripBookedBySection selectedPayer={selectedPayer} />
          <TripDetailsFormSection />
        </AddATripFlowForm>
      </AddATripFlowDialog>
      <PassengerFormDialog
        open={isEditingPassenger}
        setOpen={(open) => {
          dispatch(addATrip.actions.setIsEditingPassenger(open));
        }}
        passenger={passenger || undefined}
      />
    </>
  );
}
